import Products from '../Products/Products'
import SearchSuggestions from '../SearchSuggestions/SearchSuggestions'
import Highlight from '../Highlight/Highlight'

const SearchFlyout = ({
    suggestions,
    handleSuggestionClick,
    pages,
    collections,
    products,
    query,
}) => {
    return (
        <div className="search-flyout-outer">
            <div className="search-flyout-inner">
                <div className="flyout-sections-outer">
                    <div className="flyout-sections-inner">
                        <div className="flyout-section-stack">
                            <SearchSuggestions
                                query={query}
                                suggestions={suggestions}
                                handleSuggestionClick={handleSuggestionClick}
                            />
                            <div className="flyout-section flyout-section-outer pages-section">
                                <div className="flyout-section-inner">
                                    <h3 className="flyout-section-title">
                                        Pages
                                    </h3>
                                    {pages && pages.length > 0 ? (
                                        <ul className="pages-list nostyle">
                                            {pages.map((page) => {
                                                return (
                                                    <li key={page.id}>
                                                        <a href={page.url}>
                                                            <Highlight
                                                                search={query}
                                                            >
                                                                {page.title}
                                                            </Highlight>
                                                        </a>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    ) : (
                                        <div className="no-results">
                                            No results found
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="flyout-section flyout-section-outer collections-section">
                                <div className="flyout-section-inner">
                                    <h3 className="flyout-section-title">
                                        Collections
                                    </h3>
                                    {collections && collections.length > 0 ? (
                                        <ul className="collections-list nostyle">
                                            {collections.map((collection) => {
                                                if (
                                                    collection.title.indexOf(
                                                        'hidden'
                                                    ) === -1 &&
                                                    collection.handle.indexOf(
                                                        'test'
                                                    ) === -1
                                                ) {
                                                    return (
                                                        <li key={collection.id}>
                                                            <a
                                                                href={`/collections/${collection.handle}`}
                                                            >
                                                                <Highlight
                                                                    search={
                                                                        query
                                                                    }
                                                                >
                                                                    {
                                                                        collection.title
                                                                    }
                                                                </Highlight>
                                                            </a>
                                                        </li>
                                                    )
                                                }
                                                return null
                                            })}
                                        </ul>
                                    ) : (
                                        <div className="no-results">
                                            No results found
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="flyout-section flyout-section-outer products-section">
                            <div className="flyout-section-inner">
                                <h3 className="flyout-section-title">
                                    Products
                                    <a
                                        href={`/pages/search?q=${query}`}
                                        className="view-all"
                                    >
                                        View All »
                                    </a>
                                </h3>
                                {products && products.length > 0 ? (
                                    <Products
                                        products={products}
                                        query={query}
                                    />
                                ) : (
                                    <div className="no-results">
                                        No results found
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SearchFlyout
